import React from "react";
import { observer } from "mobx-react";
import classnames from "classnames";
import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { availableTeamStandingsDesktopFilterOptions } from "@state/stores/offer/statistics/TeamStandingsStatsStore";
import { useTranslation } from "react-i18next";
import { DropdownWrapper } from "@components/dropdown";

export const TeamStandingsMultiSelectDropdown = observer(function TeamStandingsMultiSelectDropdown({
    store,
}: {
    store: EventViewStore | AdditionalOfferViewStore;
}) {
    const { t } = useTranslation();
    const panelContent = (
        <>
            {/* Tabs */}
            <section>
                <p className="event_standings_dropdown__title">
                    {t("EVENT.HEADER.SELECT_TEAM_STANDINGS_STATS_FILTER")}
                </p>

                {store.teamStandingsStatsStore.availableTeamStandingsTabs.map(
                    (tableGroup) =>
                        tableGroup && (
                            <label
                                key={tableGroup.key}
                                className={classnames(
                                    "event_standings_dropdown__option input--select__option",
                                    {
                                        "u-type--wgt--semibold is-active":
                                            store
                                                .teamStandingsStatsStore
                                                .activeTab ===
                                            tableGroup.key,
                                        "":
                                            store
                                                .teamStandingsStatsStore
                                                .activeTab !==
                                            tableGroup.key,
                                    }
                                )}>
                                <input
                                    type="radio"
                                    name="standingsTab"
                                    className="u-mar--left--micro input--radio__box input--radio--sml__box"
                                    checked={store.teamStandingsStatsStore.activeTab === tableGroup.key}
                                    onChange={() =>
                                        store.teamStandingsStatsStore.handleTeamStandingsDropdownSelection(tableGroup.key)
                                    }
                                />
                                {t(tableGroup.title)}
                            </label>
                        )
                )}
            </section>

            {/* Table options */}
            <section>
                <p className="event_standings_dropdown__title">
                    {t("EVENT.HEADER.SELECT_TEAM_STANDINGS_STATS_TABLE")}
                </p>

                {availableTeamStandingsDesktopFilterOptions.map(
                    (group) =>
                        group && (
                            <label key={group.key}
                                className={classnames(
                                    "event_standings_dropdown__option input--select__option input--select--multi__option",
                                    {
                                        "u-type--wgt--semibold is-active":
                                            store
                                                .teamStandingsStatsStore
                                                .teamStandingsFilter ===
                                            group.key,
                                        "u-type--wgt--regular":
                                            store
                                                .teamStandingsStatsStore
                                                .teamStandingsFilter !==
                                            group.key,
                                    }
                                )}>
                                <input
                                    type="radio"
                                    name="standingsTable"
                                    className="u-mar--left--micro input--radio__box input--radio--sml__box"
                                    checked={store.teamStandingsStatsStore.teamStandingsFilter === group.key}
                                    onChange={() =>
                                        store.teamStandingsStatsStore.handleTeamStandingsDropdownSelection(
                                            group.key
                                        )
                                    }
                                />
                                {t(group.title)}
                            </label>
                        )
                )}
            </section>

            {/* Tournament groups */}
            {store.teamStandingsStatsStore.teamStandingsStats?.isGroupType && (
                <section>
                    <p className="event_standings_dropdown__title">
                        {t(
                            "EVENT.HEADER.SELECT_TEAM_STANDINGS_TOURNAMENT_GROUP_STATS_TABLE"
                        )}
                    </p>

                    {store.teamStandingsStatsStore.availableTeamStandingsTournamentGroups.map(
                        (tournamentGroup) => (
                            <label
                                key={tournamentGroup ?? "all"}
                                className={classnames(
                                    "event_standings_dropdown__option input--select__option input--select--multi__option",
                                    {
                                        "u-type--wgt--semibold is-active":
                                            store
                                                .teamStandingsStatsStore
                                                .teamStandingsTournamentGroup ===
                                            tournamentGroup,
                                        "u-type--wgt--regular":
                                            store
                                                .teamStandingsStatsStore
                                                .teamStandingsTournamentGroup !==
                                            tournamentGroup,
                                    }
                                )}
                            >
                                <input
                                    type="radio"
                                    name="standingsGroup"
                                    className="u-mar--left--micro input--radio__box input--radio--sml__box"
                                    checked={store.teamStandingsStatsStore.teamStandingsTournamentGroup === tournamentGroup}
                                    onChange={() =>
                                        store.teamStandingsStatsStore.handleTeamStandingsDropdownSelection(
                                            tournamentGroup
                                        )
                                    }
                                />
                                {tournamentGroup === "all"
                                    ? t("EVENT.STATISTICS.TEAM_STANDINGS.BUTTONS.ALL")
                                    : t(tournamentGroup)}
                            </label>
                        )
                    )}
                </section>
            )}
        </>
    );


    return (
        <DropdownWrapper
            wrapperClassName="event__tabs__filter"
            renderTrigger={({ toggle }) => (
                <button
                    className="event__tabs__select input input--sml input--select"
                    onClick={toggle}
                >
                    <label className="event__tabs__label" aria-hidden="true">
                        {t("EVENT.HEADER.STANDINGS_APPEARANCE")}
                    </label>
                </button>
            )}
        >
            {panelContent}
        </DropdownWrapper>
    );
});
